import { makePaymentForCancel } from '../../actions/booking/makePaymentForCancel';
import { processStripePayment } from './../../core/payment/stripe/processStripePayment';

async function submit(values, dispatch) {
  console.log('working', values)
  // === STRIPE =========================
  const { creditCard, cvv, expDate, guestId, currency, title, totalAmount, listId, reservationId, guestEmail } = values;
// expDate example --> '10/22'
  const splitDate = expDate.split('/')
  const cardDetails = {
    number: creditCard,
    exp_month: splitDate[0],
    exp_year: `20${splitDate[1]}`,
    cvc: cvv
  };

  const reservationDetails = {
		guestId,
		guestEmail: guestEmail,
		amount: totalAmount,
		currency,
		reservationId,
		listId,
		title
	};
	console.log('reservation details client', reservationDetails)
processStripePayment('reservation', cardDetails, reservationDetails);

	// ====================================

	// ======= Paypal payment =============
	// dispatch(makePaymentForCancel(
	// 	values.reservationId,
	// 	values.amount,
	// 	values.currency,
	// 	values.paymentCurrency,
	// 	values.title
	// )
	// );
	// =====================================
	//dispatch(reset('PaymentForm'));
}

export default submit;


// WEBPACK FOOTER //
// ./src/components/Payment/submit.js